module.exports = __webpack_public_path__ + "static/Lato-Regular-e87e43c57f21dd637791c6bfa534c1af.woff";